module.exports = __webpack_public_path__ + "img/riskGreen.a809dedd.png";